import { formatTaskDateTime } from "./taskDateTime";

export const isPublicKeyMissingError = ({ vapiError }) => {
  return !!vapiError && vapiError.error.statusCode === 403 && vapiError.error.error === "Forbidden";
};

export const DateFormtter = (date, timezone) => formatTaskDateTime(date, timezone);
